// extracted by mini-css-extract-plugin
export default {"main":"BreadCrumbs_main__CuEpd","box":"BreadCrumbs_box__fnwmk","menu_link":"BreadCrumbs_menu_link__-0CpY","menu_text":"BreadCrumbs_menu_text__QJHGh"};